<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5 text-uppercase" >{{page}}</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link :to="`/${page}/add`" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Add {{page}}
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">{{page}} List</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="dataList" :fields="tableFields">
                <template #cell(actions)="row">
                  <router-link :to="`/${page}/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button @click="removeItem(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="fe fe-trash-2"></i>
                  </button>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'
const page = 'country'
export default {
  name: 'Country',
  data () {
    return {
      page: page,
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      dataList: state => state[page].dataList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'title_l.' + this.$i18n.locale,
          label: 'Title',
          sortable: true
        },
        {
          key: 'continent.title_l.' + this.$i18n.locale,
          label: 'Continent',
          sortable: true
        },
        {
          key: 'iso_code',
          label: 'Iso code',
          sortable: true
        },
        {
          key: 'external_code',
          label: 'External Code',
          sortable: true
        },
        {
          key: 'actions',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getData({ count: this.paginationPerPage })
  },
  methods: {
    ...mapActions({
      getAllData: page + '/getAllData',
      deleteItem: page + '/delete'
    }),
    getData (params) {
      this.getAllData(params).then(res => {
        this.pagination = res.pagination
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
    },
    changePaginationPerPage (value) {
      this.getData({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getData({ page: page, count: this.paginationPerPage })
    },
    removeItem (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteItem({ id }).then(res => {
          }).catch(err => {
            if (err && err.response) {
              if (err.response.status === 422) {
                const data = err.response.data.errors
                const keys = Object.keys(data)
                const msg = data[keys[0]]
                this.$toasted.error(msg).goAway(1500)
              } else {
                this.$toasted.error(err.response.message).goAway(1500)
              }
            }
          })
        }
      })
    }
  }
}
</script>

<style>
  .is_main {
    transform: scale(1.5);
    -ms-transform: scale(1.5);
    -webkit-transform: scale(1.5);
    cursor: pointer;
  }
</style>
